import { BACKEND } from "../config/configEnvs";
import axios from "axios";
import { toast } from "react-toastify";
import FetchRUC from "./externalAPIs/FetchRuc";

const HandleUpdateRUC = async ({
  field,
  newValue,
  updateField,
  targetID,
  route,
  debounceUpdate,
  setElements = null,
  setElement = null,
  element = null,
}) => {
  if (setElements) {
    setElements((prev) =>
      prev.map((e) => (e.id === targetID ? { ...e, [field]: newValue } : e))
    );
  }

  if (setElement && element) {
    setElement({ ...element, [field]: newValue });
  }

  if (field !== "ruc" || newValue?.length !== 11) {
    return;
  }

  const result = await FetchRUC({ ruc: newValue });

  if (!result || !result.brandName) {
    toast.error("El RUC no existe");
    return;
  }

  const { brandName } = result;

  if (setElements && brandName) {
    setElements((prev) =>
      prev.map((e) =>
        e.id === targetID ? { ...e, [updateField]: brandName } : e
      )
    );
  }

  if (setElement && element && brandName) {
    setElement({ ...element, [updateField]: brandName, [field]: newValue });
  }

  if (debounceUpdate.current) {
    clearTimeout(debounceUpdate.current);
  }

  debounceUpdate.current = setTimeout(async () => {
    try {
      await axios.put(`${BACKEND}/api/${route}/${targetID}`, {
        [field]: newValue,
        [updateField]: brandName,
      });

      toast.success("RUC validado con éxito!");
    } catch (e) {
      toast.error("Error al actualizar el dato: " + e.message);
    }
  }, 2000);
};

export default HandleUpdateRUC;
